<!-- 添加个人记工-点工弹窗-->
<template>
  <div class="">
    <el-dialog
      :title="modalTitle"
      :visible.sync="visible"
      width="800px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleBeforeClose"
    >
      <el-row class="title">
        <el-col :span="24" style="color:#333"><span>当前项目：</span>{{ form.projectName }}</el-col>
      </el-row>
      <div class="content">
        <el-form :model="form" label-position="right" label-width="180px" :rules="rules" ref="formRef">
          <el-form-item label="日期（可选多天）：" prop="workTime">
            <el-button class="btn_c666" @click="$refs.selectCalendar.open()">
              {{
                form.workTime.split(',').length > 1
                  ? `共选择${form.workTime.split(',').length}天 >`
                  : showWorkTime
              }}
            </el-button>
          </el-form-item>
          <el-form-item label="上班时长：" prop="workDuration" style="margin-bottom: 9px;">
            <el-radio-group v-model="workType">
              <el-radio border label="1">
                一个工
              </el-radio>
              <el-radio border label="2" @click.native="changeWorkType('2');workDaySelectShow = true">
                {{ workDay }}{{ isNaN(workDay) ? "" : "个工 >" }}
              </el-radio>
              <el-radio border label="3">
                休息
              </el-radio>
              <el-radio border label="4" @click.native="changeWorkType('4');workTimeSelectShow = true">
                {{ workDuration }}{{ isNaN(workDuration) ? "" : "小时 >" }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="加班时长：" prop="workOvertimeDuration" style="margin-bottom: 9px;">
            <el-radio-group v-model="workOverType">
              <el-radio border label="1">
                无加班
              </el-radio>
              <el-radio border label="2" @click.native="changeWorkOverType();overTimeSelectShow = true">
                {{ workOverTime }}{{ isNaN(workOverTime) ? "" : "小时 >" }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择工人：" prop="workNoList" v-if="form.recordType==='2'" ref="formSelectWorker" style="margin-bottom: 22px;">
            <el-button class="btn_c666" @click="$refs.selectWorker.open(form.workNoList)">选择工人 ></el-button>
            <span style="margin-left: 16px" v-if="workerInfoArr.length">已选择{{workerInfoArr[0].name}}等{{form.workNoList.length}}人</span>
          </el-form-item>
          <el-form-item label="工资标准：" style="margin-bottom:0" v-if="form.recordType==='1'">
            <el-button @click="setSalaryStandardShow=true" size="small" type="primary" class="setsalary_btn">设置工资标准</el-button>
            <span style="color:#666;margin-left:20px">
              上班{{ form.workStandardSalary || '--' }}元 / 工，加班{{
                form.workOvertimeSalary || '--'
              }}元 / 小时
            </span>
          </el-form-item>

          <el-form-item label="当日工钱（自动计算）：" style="margin-bottom:0px" v-if="form.recordType==='1'">
            <span style="color: #FF6600">{{ toDaySalary }}</span> 元
          </el-form-item>

          <el-form-item label="备注：" prop="remark" style="margin-bottom:12px">
            <el-input v-model="form.remark" :maxlength="300" placeholder="请填写备注"></el-input>
          </el-form-item>

          <el-form-item label="上传备注图片：" style="margin-bottom: 0">
            <el-upload
              ref="upload"
              :action="actionURL"
              list-type="picture-card"
              class="upload"
              :on-success="onSuccess"
              :on-remove="onRemove"
              :on-exceed="onExceed"
              :before-upload="beforeUpload"
              accept=".jpg,.png,.jpeg"
              :limit="5"
              multiple
              :class="{hide_upload:this.form.picture.split(',').length>=5}"
            >
              <div class="upload_icon">
                <i class="el-icon-plus"></i>
                上传
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="flex_jc_center footer">
        <el-button @click="handleBeforeClose">取 消</el-button>
        <el-button type="primary"  @click="save" style="margin-left:15px">保 存</el-button>
      </div>
    </el-dialog>

    <SelectCalendar ref="selectCalendar" :year="workYear" :math="workMonth" :check="true"
                    :value.sync="form.workTime"></SelectCalendar>

    <!-- 选择上班时长弹窗 天数 -->
    <WorkDaySelect :visiable.sync="workDaySelectShow"  :value.sync="workDay" @save="lastWork.workType=workType" @cancel="cancelWork"></WorkDaySelect>
    <!--  选择上班时长弹窗 小时  -->
    <WorkTimeSelect :visiable.sync="workTimeSelectShow"  :value.sync="workDuration" @save="lastWork.workType=workType" @cancel="cancelWork"></WorkTimeSelect>
    <!--  选择加班时长弹窗  -->
    <WorkOverTimeSelect :visiable.sync="overTimeSelectShow"  :value.sync="workOverTime"
                    @save="form.workOvertimeDuration = workOverTime;lastOverWork.workOverType=workOverType" @cancel="cancelWorkOver"></WorkOverTimeSelect>
    <!--  设置工资标准弹窗-->
    <setSalaryStandard :visiable.sync="setSalaryStandardShow" :detail.sync="form" ref="setSalaryStandard"></setSalaryStandard>

    <!--    选择工人-->
    <select-worker ref="selectWorker" @save="saveWorker"></select-worker>
  </div>
</template>

<script>
import {api} from "@/api/apiRecord.js"

export default {
  components: {
    SelectCalendar: () => import("./selectCalendar.vue"), // 日历
    WorkTimeSelect: () => import("./workTimeSelect"), // 选择工作时长弹窗
    WorkOverTimeSelect: () => import("./workTimeSelect"), // 选择加班时长弹窗
    setSalaryStandard: () => import("./setSalaryStandard"), // 设置工资标准弹窗
    WorkDaySelect: () => import("./workDaySelect"), // 选择工作时长弹窗
    SelectWorker: ()=>import("./SelectWorker") // 选择工人
  },
  props: {
    visible: {
      type: Boolean
    },
    project: { // 项目信息对象
      type: [Object, undefined]
    },
    workRecordNo: { // 项目no
      type: String,
    }
  },
  data() {
    return {
      workerInfoArr:[],
      actionURL: `${process.env.VUE_APP_APITEAM}/file/addFiles`, // 图片上传地址
      workOverType: "1", // 加班类型
      workOverTime: "选择小时 >",// 加班时长
      workType: "1", // 上班时长种类
      workDuration: "选择小时 >",// 上班时长
      workDay: "输入天数 >", // 上班多少小时
      form: {
        haveWorkOvertime: "1",//加班类型1:无加班,2:有加班
        id: "",
        no: "", //点工流水no
        picture: "",//图片地址
        projectName: "",//项目名称
        projectNo: "",//项目编号
        remark: "", // 备注
        salary: "",//当日工钱
        userNo: "",//用户no
        workDuration: "1",//工作单位数量
        workOvertimeDuration: "0",//加班时长数量
        workOvertimeSalary: "", // 加班薪资,单位小时
        workOvertimeStandard: "", // 加班标准(加班几小时算一个工)
        workOvertimeType: "1", // 加班计算方式:1:按天,2:按小时
        workStandard: "", // 上班标准(几个小时一个工)
        workStandardSalary: "", // 每个工多少钱
        workTime: "",// 工作时间
        workType: "1",// 时长类型(1按一个工,2按输入工天,3:休息,4:按小时)
        recordType: "", // 记账类型(1:个人,2班组)
        workNoList:[]
      },
      workYear: "", // 选中的年份
      workMonth: "", // 选中的月份
      workTimeSelectShow: false,
      overTimeSelectShow: false,
      setSalaryStandardShow: false,
      workDaySelectShow: false,
      rules: {
        workTime: [{required: true}],
        workDuration: [{required: true}],
        workOvertimeDuration: [{required: true}],
        workNoList:[{required: true, message: '请选择工人',type: 'array'}]
      },
      lastOverWork:{ // 上次加班的选项
        workOverType:"",
        workOverTime:""
      },
      lastWork:{
        workType:"",
        workTime:""
      },
      loading:false
    }
  },
  mounted() {
    this.workYear = new Date().getFullYear()
    this.workMonth = new Date().getMonth() + 1
  },
  methods: {
    getToDay() {
      return `${new Date().getFullYear()}-` + `0${new Date().getMonth() + 1}`.substr(-2) + `-` + `0${new Date().getDate()}`.substr(-2)
    },
    // 关闭弹窗初始化表单数据
    handleBeforeClose() {
      this.$emit("update:visible", false)
      this.workOverType="1" // 加班类型
      this.workOverTime="选择小时 >"// 加班时长
      this.workType="1" // 上班时长种类
      this.workDuration="选择小时 >"// 上班时长
      this.workDay="输入天数 >" // 上班多少小时
      this.form.picture=""
      this.form.workOvertimeStandard=""
      this.form.workOvertimeType="1"
      this.form.workStandard=""
      this.form.workStandardSalary=""
      this.form.workOvertimeDuration = "0"
      this.form.workDuration="1"
      this.$nextTick(()=>{
        this.form.workNoList=[]
        this.workerInfoArr=[]
      })
      this.$refs.setSalaryStandard.salaryForTime=""
      this.$refs.upload.clearFiles()
      this.$refs.formRef.resetFields()
    },
    // 切换上班时长类型,设置上班时长数量
    handleWorkType(type, time) {
      this.form.workType = type
      this.form.workDuration = isNaN(time)?"0":time
    },
    // 切换加班类型 加班类型1:无加班,2:有加班
    handleHaveWorkOvertime(type, time) {
      this.form.haveWorkOvertime = type
      this.form.workOvertimeDuration = isNaN(time)?"0":time
    },
    // 更改上班时长类型
    changeWorkType(v) {
      const val = v ? v : this.workType
      if (val === "1") {
        this.handleWorkType('1', '1')
      } else if (val === "2") {
        this.handleWorkType('2', this.workDay)
      } else if (val === "3") {
        this.handleWorkType('3', '0')
      } else if (val === "4") {
        this.handleWorkType('4', this.workDuration)
      }
    },
    // 更改加班时长类型
    changeWorkOverType() {
      const val = this.workOverType
      if (val === "1") {
        this.handleHaveWorkOvertime('1', '0')
      } else if (val === "2") {
        this.handleHaveWorkOvertime('2', this.workOverTime)
      }
    },
    // 保存点工详情
    save() {
      if(this.loading) return
      this.loading = true
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return this.loading=false
        // if (!this.form.workStandard || !this.form.workStandardSalary || !this.form.workOvertimeSalary) return this.$message.warning('请设置工资标准')
        if(isNaN(this.form.workDuration)){
          this.form.workDuration="0"
        }

        this.form.workOvertimeDuration=isNaN(this.form.workOvertimeDuration)?"0":this.form.workOvertimeDuration


        this.form.projectNo = this.project.no || this.project.projectNo
        this.form.projectName = this.project.projectName
        this.form.no=this.workRecordNo
        this.form.salary = isNaN(this.toDaySalary)?"":this.toDaySalary
        this.form.userNo = this.$store.getters.getUser.no
        if(this.form.recordType==='2'){
          delete this.form.workOvertimeSalary
          delete this.form.workOvertimeStandard
          delete this.form.workOvertimeType
          delete this.form.workStandard
          delete this.form.workStandardSalary
        }else if(this.form.recordType==='1'){
          delete this.form.workNoList
        }

        const delectArr = ['workerName','createTime','createUser','isDeleted','isEnable','updateUser','updateTime']
        delectArr.forEach(item=>{
          delete this.form[item]
        })
        const res = await api.workRecordAdd(this.form)
        if (res.data.code === 200) {
          this.$message.success('保存成功')
          this.$emit('close')

          if(this.form.recordType==='2'){
            this.handleBeforeClose()
            return
          }
          // 设置工资标准
        const params = {
          projectName: this.form.projectName,
          projectNo: this.form.projectNo,
          workOvertimeSalary: this.form.workOvertimeSalary,
          workOvertimeStandard: this.form.workOvertimeStandard,
          workOvertimeType: this.form.workOvertimeType,
          workStandard: this.form.workStandard,
          workStandardSalary: this.form.workStandardSalary,
          type: this.form.recordType
        }
        const result = await api.PointSalaryAdd(params)
        if (result.data.code === 200) {
          this.handleBeforeClose()
        }else if(result.data.code === 500){
          this.loading = false
        }
        }else if(res.data.code === 500){
          this.$message.error('保存失败')
          this.loading = false
        }

      })
    },
    // 获取项目详情
    async getProjectDetail() {
      const params = {
        no:this.workRecordNo,
        type:this.$route.query.type?this.$route.query.type:'1'
      }
      const res = await api.workRecordDetail(params)
      if (res.data.code === 200) {
        this.form = Object.assign(this.form,res.data.data)
        const data = res.data.data
        if(this.$route.query.type==='2'){ // 班组点工
          this.form.workTime = data.workDate
        }else { // 个人点工，对后端返回的时间戳转换
          const time = new Date(data.workTime)
          this.form.workTime = time.getFullYear()+'-'+('0'+(time.getMonth()+1)).substr(-2)+'-'+('0'+time.getDate()).substr(-2)
        }
        this.form.picture = data.picture
        if(data.picture){
          this.$refs.upload.fileList= data.picture.split(',').map(item=>{
            return {url:item}
          })
        }
        this.workOverType = data.haveWorkOvertime // 加班类型
        if(this.workOverType=="2"){
            this.workOverTime = data.workOvertimeDuration // 加班时长
        }else{
          this.workOverTime = "选择小时 >" // 加班时长
        }


        this.workType = data.workType // 上班时长类型
        if(this.workType=="2"){
          this.workDay=data.workDuration
        }else if(this.workType=="4"){
          this.workDuration=data.workDuration // 上班时长
        }else{
          this.form.workDuration=data.workDuration
        }


      this.$nextTick(()=>{
        this.lastOverWork.workOverType = data.haveWorkOvertime
        this.lastWork.workType = data.workType

      })


        if (this.workType === '2') {
          this.workDay = this.form.workDuration // 上班多少天
        } else if (this.workType === '4') {
          this.workDuration = this.form.workDuration // 工作单位数量
        }
        this.form.recordType==='1' && this.setLatestSalaryStandard()
      }
    },
    // 图片上传成功
    onSuccess(response) {
      let arr = this.form.picture ? this.form.picture.split(',') : []
      arr.push(response.data[0].uuid)
      this.form.picture = arr.join()
    },
    // 删除图片
    onRemove(file) {
      const deleteImgUrl = file.response ? file.response.data[0].uuid : file.url
      let arr = this.form.picture ? this.form.picture.split(',') : []
      arr = arr.filter(item => {
        return item !== deleteImgUrl
      })
      this.form.picture = arr.join()
    },
    // 上传图片超过5张
    onExceed() {
      this.$message.warning('最多上传5张图片')
    },
    // 图片上传之前
    beforeUpload(file) {
      if (file.size / 1024 / 1024 >= 10) {
        this.$message.warning('只能上传10M以下的图片')
        return false
      }
    },
    // 获取最新的工资标准并设置
    async setLatestSalaryStandard(){
      const parmas = {
        projectNo:this.project.no,
        type:this.form.recordType // 类型(1:个人,2班组)
      }
      const res = await api.getLatestSalaryStandard(parmas)
      if(res.data.code===200){
        if(res.data.data){
          const data=res.data.data
          this.form.workOvertimeSalary=data.workOvertimeSalary?Number(data.workOvertimeSalary).toFixed(2):""
          this.form.workOvertimeStandard=data.workOvertimeStandard
          this.form.workOvertimeType=data.workOvertimeType
          this.form.workStandard=data.workStandard
          this.form.workStandardSalary=data.workStandardSalary?Number(data.workStandardSalary).toFixed(2):""
        }else{
          this.form.workOvertimeSalary=""
          this.form.workOvertimeStandard=""
          this.form.workOvertimeType="1"
          this.form.workStandard=""
          this.form.workStandardSalary=""
        }
      }
    },
    cancelWorkOver(){
        this.workOverType=this.lastOverWork.workOverType
    },
    cancelWork(){
        this.workType=this.lastWork.workType
    },
    /**
     * 保存选择的工人
     * @param v {Array} 选择的工人no数组
     * @param workerInfoArr {Array} 选择的工人名字数组
     * */
    saveWorker(v,workerInfoArr){
      this.form.workNoList = v
      this.workerInfoArr = workerInfoArr
      this.$refs.formSelectWorker.validate()
    }
  },
  watch: {
    workType(newVal,oldVal) { // 上班时长类型改变
      this.changeWorkType()
      this.lastWork.workType=oldVal
    },
    workOverType(newVal,oldVal) { // 加班时长类型改变
      this.changeWorkOverType()
      this.lastOverWork.workOverType=oldVal
    },
    workDuration(val) {
      this.form.workDuration = val
    },
    workDay(val) {
      if (val === "0" || !val) { // 如果选择0 或没有选择，工作时长变为休息
        this.workType = "3"
        this.workDay="0"
      }
      this.form.workDuration = val
    },
    workOverTime(val) {
      this.form.workOvertimeDuration = val
    },
    visible(val) {
      if (!val || !this.project) return
      this.loading=false

      if (this.workRecordNo) { // 编辑
        const recordType = this.$route.query.type?this.$route.query.type:'1'
        if(recordType==='2'){
          this.form.projectNo=this.project.projectNo
          this.form.workNoList=this.project.workNoList
          this.form.operateNum=this.project.operateNum
          this.workerInfoArr=[{name:this.project.workerName}]
        }
        this.getProjectDetail()
        this.form.recordType=recordType
      } else { // 新增
        if (!this.projectNo) { // 新增设置项目no，项目名称
          this.form.projectNo = this.project.no
          this.form.projectName = this.project.projectName
        }
        this.form.workDuration="1"
        this.form.workOvertimeDuration="0"

        if(this.$parent.day){
          this.form.workTime=String(this.$parent.day.cYear)+'-'+('0'+this.$parent.day.cMonth).substr(-2)+'-'+this.$parent.day.cDay
        }else{
          this.form.workTime = this.getToDay()
        }
      }
      this.form.recordType=this.$route.query.type?this.$route.query.type:'1'
      this.form.recordType==='1' && this.setLatestSalaryStandard()
    },
  },
  computed: {
    toDaySalary() { // 当日工资
      // 有工资标准  休息 无加班
      if (this.form.workType === "3" && this.form.haveWorkOvertime === "1" && this.form.workStandard) return "0.00"

      // 未设置工资标准
      if (!this.form.workStandard || !this.form.workStandardSalary || !this.form.workOvertimeSalary) return "--"
      if (this.workType === "4") {
        const toDaySalary = this.form.workStandardSalary * (this.form.workDuration / this.form.workStandard) + this.form.workOvertimeDuration * this.form.workOvertimeSalary
        return isNaN(toDaySalary) ? "--" : toDaySalary.toFixed(2)
      }
      const toDaySalary = this.form.workStandardSalary * this.form.workDuration + this.form.workOvertimeDuration * this.form.workOvertimeSalary
      return isNaN(toDaySalary) ? "--" : toDaySalary.toFixed(2)
    },
    showWorkTime() {
      const time = this.form.workTime.split("-")
      return `${time[0]}年${time[1]}月${time[2]}日 >`
    },
    // 模态框标题
    modalTitle(){
      return (this.form.recordType==='1'?'个人':'班组')+'记工-点工'
    }
  }
}
</script>

<style lang="scss" scoped>
.bg_gold {
  background: #B79255;
}

.color_fff {
  color: #fff;
}
.el-button--primary {
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  // width: 58px;
  height: 34px;
  padding: 0 15px;
  font-size: 14px;
  &:hover,&:focus{
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  }
  }
.upload {

  /deep/ .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}

/deep/ .el-upload {
  width: 100px;
  height: 100px;
}

/deep/ .el-dialog__body {
  padding: 0;
}

.el-button {
  border-radius: 4px;
  padding: 9px 20px;
}

.upload_icon {
  width: 100px;
  height: 100px;
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  i {
    margin-bottom: 10px;
    color: #0286DF;
  }
}

.title {
  padding: 0 20px;
  background: #F5F7FA;
  line-height: 40px;
  font-size: 16px;

  span {
    color: #666;
    font-weight: normal;
  }
}

.content {
  padding: 20px 20px 0 5px;
}


/deep/ .el-dialog__footer {
  padding: 40px;
}

.calendar_wrap {
  padding: 30px 96px 0;

  > div {
    padding: 30px 20px;
    border: 1px solid #B79255;
    border-radius: 7px;
  }

  .time_wrap {
    margin-bottom: 20px;
  }
}

.hide_upload {
  /deep/ .el-upload {
    display: none;
  }
}

/deep/ .el-radio{
  margin-right: 10px;
}

/deep/ .el-upload-list__item-status-label {
  display: none !important;
}
.setsalary_btn{
  font-size: 14px;
  padding: 7px 13px
}
/deep/ .el-radio{
  height: 34px !important;
  padding: 9px 20px 0 10px !important;
}
/deep/.el-radio.is-bordered.is-checked{
  color: #0286df;
  border-color: #0286df;
  span {
    color: #0286df;
  }
}
/deep/ .el-input__inner{
  height: 34px;
}
/deep/.el-form-item{
  margin-bottom: 7px
}
.btn_c666 {
  color:#666666 !important;
  border-color:#dcdfe6 !important;
  border-radius: 4px;
  &:hover{
    color:#666666 !important;
    border-color:#dcdfe6 !important;
  }
}
.footer {
  .el-button{
    padding: 9px 12px;
  }
}
</style>
